import React, { useEffect, useRef, useState } from "react";
import { notEmptyValidation } from "../../../functions/validations";
import useOnClickOutside from "../../../hooks/useOnClickOutside";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const InputSelect = (props) => {
  const {
    label,
    options,
    value,
    onClickItem,
    itemKey,
    searchable,
    validation,
    errorText,
    size = "md",
    hideLabel,
    placeholder,
    className,
    disabled,
    alternateBg,
  } = props;

  const [search, setsearch] = useState(value ? value[itemKey] : "");
  const [list, setlist] = useState(options);
  const [listVisible, setlistVisible] = useState(false);
  const [error, seterror] = useState(null);

  useEffect(() => {
    setsearch(value[itemKey] ? value[itemKey] : "");
  }, [value]);

  const listRef = useRef();
  useOnClickOutside(listRef, () => {
    value ? setsearch(value[itemKey]) : setsearch("");
    setlistVisible(false);
  });

  useEffect(() => {
    setlist(options);
  }, [options]);

  useEffect(() => {
    if (search) {
      const newList = options.filter((item) => item[itemKey].toLowerCase().includes(search.toLowerCase()));

      setlist(newList);
    } else {
      setlist(options);
    }
  }, [search]);

  function checkValidation() {
    if (validation === "ne") {
      !notEmptyValidation(search) && seterror(errorText ? errorText : "Required Input");
    } else {
      seterror(null);
    }
  }

  return (
    <div className={`input-select ${size} ${error ? "input-error" : ""} ${className}`}>
      {!hideLabel && <p className="label">{label ? label : placeholder}</p>}

      <div className="input">
        <div className="btn" onClick={() => setlistVisible((prevProps) => !prevProps)}>
          {searchable ? (
            <input
              type="text"
              placeholder={placeholder ? placeholder : label}
              value={search}
              onChange={(e) => {
                seterror(null);
                setsearch(e.target.value);
              }}
              onBlur={checkValidation}
              disabled={disabled}
            />
          ) : (
            <div className="flex-jb-ac" style={{ width: "100%" }}>
              <p style={{ fontSize: !value ? "1.2rem" : "unset", color: !value ? "var(--color-grey-light)" : "unset" }}>
                {value ? value : placeholder ? placeholder : label}
              </p>
              {listVisible ? (
                <ExpandLessIcon style={{ color: "var(--color-grey-light)" }} />
              ) : (
                <ExpandMoreIcon style={{ color: "var(--color-grey-light)" }} />
              )}
            </div>
          )}
          <i className={listVisible ? "fa-solid fa-chevron-up" : "fa-solid fa-chevron-down"}></i>
        </div>
        {list.length && listVisible ? (
          <div
            className="list"
            ref={listRef}
            style={{
              backgroundColor: alternateBg ? "var(--color-background)" : "var(--color-light)",
            }}
          >
            {list.map((item, i) => (
              <div
                className="item"
                key={i}
                onClick={() => {
                  seterror(null);
                  onClickItem(item);
                  searchable && setsearch(item[itemKey]);
                  setlistVisible(false);
                }}
              >
                <p>{item[itemKey]}</p>
              </div>
            ))}
          </div>
        ) : search && !list.length ? (
          <div className="no-data" ref={listRef}>
            <p>No Data for {search}</p>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default InputSelect;
